import { useCallback } from 'react';
import { useAuthStore } from '../../../stores/auth.store';
import { config } from '../../../config/config';
import { getUidFromJwt } from '../../../utils/jwt';
import { Account } from '../../../models/user.model';
import { createConfig, mbCoreApi } from '../api';

export const useFetchAccounts = () => {
  const accessToken = useAuthStore(state => state.accessToken);

  const func = useCallback(async (): Promise<Account[]> => {
    if (!accessToken) {
      throw new Error('useFetchAccounts: No accessToken!');
    }

    try {
      console.log('fetching accounts....');
      const userId = getUidFromJwt(accessToken);

      const response = await mbCoreApi.get(
        `${config.apiUrl}/v1/users/${userId}/accounts`,
        createConfig(accessToken),
      );

      if (!response || !response.data) {
        return Promise.reject(new Error('useFetchAccounts: No data'));
      }

      return response.data;
    } catch (e: any) {
      throw new Error('useFetchAccounts:', e);
    }
  }, [accessToken]);

  return {
    fetchAccounts: func,
  };
};
